import React from 'react';

import { Login } from '~/components/login';

function LoginContainer() {
  return <Login />;
}

export default LoginContainer;
